import {useSearchParams} from "react-router-dom";
import {categoryStore} from "../../../../Stores/CategoryStore";
import {getUniqueLeafFilters} from "../../../../Utilities/categoryUtils";
import {DropDownFilterDesktop} from "./DropDownFilterDesktop";
import Space from "../../../Common/Space";
import {Typography} from "@mui/material";
import {observer} from "mobx-react-lite";

export const CustomFilterDesktop = observer(() => {
    const [searchParams] = useSearchParams();
    const path = searchParams.get("category")?.split(" > ");

    if (!categoryStore.isInitialized || !path?.length)
        return <></>

    const level = path.reduce((current, name) => {
        const list = Array.isArray(current) ? current : current.children;
        return list.find(item => item.name === name);
    }, categoryStore.categoryTree);

    const filters = [];
    const leafFilters = getUniqueLeafFilters(level);

    Object.entries(leafFilters).forEach(([key, filter]) => {
        if (filter.type === "dropdown") {
            filters.push(
                <DropDownFilterDesktop
                    key={`filter_${key}`}
                    filter={filter}
                />
            );
        }
    });

    if (filters.length === 0) {
        return <></>
    }

    return <>
        <Space height="20px"/>
        <Typography variant="h5" sx={{fontWeight: "bold"}}>Filtre</Typography>
        {filters}
    </>
})